import type { Section } from "Interfaces";
import { PolicyTermType } from "Interfaces";

export default
[
	{
		title: "Privacy Policy",
		data: [
			{
				subtitle: "Effective date: September 10, 2018",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`Clinton Electronics ("us", "we", or "our") operates the https://app.dynamicdns.com
							website (the "Service").`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`This page informs you of our policies regarding the collection, use, and disclosure
							of personal data when you use our Service and the choices you have associated with
							that data.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We use your data to provide and improve the Service. By using the Service, you
							agree to the collection and use of information in accordance with this policy.
							Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy
							have the same meanings as in our Terms and Conditions, accessible from
							https://app.dynamicdns.com`
					}
				]
			},
			{
				subtitle: "Information Collection And Use",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We collect several different types of information for various purposes to provide
							and improve our Service to you.`
					}
				]
			},
			{
				subtitle: "Types of Data Collected",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data: ""
					}
				]
			},
			{
				subtitle: "Personal Data",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`While using our Service, we may ask you to provide us with certain personally
							identifiable information that can be used to contact or identify you ("Personal
							Data"). Personally identifiable information may include, but is not limited to:`
					},
					{
						type: PolicyTermType.BULLETS,
						data: [
							"Email address",
							"First name and last name",
							"Phone number",
							"Address, State, Province, ZIP/Postal code, City",
							"Cookies and Usage Data"
						]
					}
				]
			},
			{
				subtitle: "Usage Data",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We may also collect information how the Service is accessed and used ("Usage
							Data"). This Usage Data may include information such as your computer's Internet
							Protocol address (e.g. IP address), browser type, browser version, the pages of
							our Service that you visit, the time and date of your visit, the time spent on
							those pages, unique device identifiers and other diagnostic data.`
					}
				]
			},
			{
				subtitle: "Tracking & Cookies Data",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We use cookies and similar tracking technologies to track the activity on our
							Service and hold certain information.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`Cookies are files with small amount of data which may include an anonymous
							unique identifier. Cookies are sent to your browser from a website and stored
							on your device. Tracking technologies also used are beacons, tags, and scripts
							to collect and track information and to improve and analyze our Service.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`You can instruct your browser to refuse all cookies or to indicate when a
							cookie is being sent. However, if you do not accept cookies, you may not be
							able to use some portions of our Service.`
					}
				]
			},
			{
				subtitle: "Examples of Cookies we use",
				data: [
					{
						type: PolicyTermType.BULLETS,
						data: [
							"Session Cookies. We use Session Cookies to operate our Service.",
							`Preference Cookies. We use Preference Cookies to remember your preferences
							and various settings.`,
							"Security Cookies. We use Security Cookies for security purposes."

						]
					}
				]
			},
			{
				subtitle: "Use of Data",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							"Clinton Electronics uses the collected data for various purposes:"
					},
					{
						type: PolicyTermType.BULLETS,
						data: [
							"To provide and maintain the Service",
							"To notify you about changes to our Service",
							`To allow you to participate in interactive features of our Service when
							you choose to do so`,
							"To provide customer care and support",
							`To provide analysis or valuable information so that we can improve the
							Service`,
							"To monitor the usage of the Service",
							"To detect, prevent and address technical issues"
						]
					}
				]
			},
			{
				subtitle: "Transfer of Data",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`Your information, including Personal Data, may be transferred to — and
							maintained on — computers located outside of your state, province, country
							or other governmental jurisdiction where the data protection laws may
							differ than those from your jurisdiction.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`If you are located outside United States and choose to provide information
							to us, please note that we transfer the data, including Personal Data, to
							United States and process it there.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`Your consent to this Privacy Policy followed by your submission of such
							information represents your agreement to that transfer.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`Clinton Electronics will take all steps reasonably necessary to ensure that
							your data is treated securely and in accordance with this Privacy Policy and
							no transfer of your Personal Data will take place to an organization or a
							country unless there are adequate controls in place including the security
							of your data and other personal information.`
					}
				]
			},
			{
				subtitle: "Disclosure of Data",
				data: []
			},
			{
				subtitle: "Legal Requirements",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`Clinton Electronics may disclose your Personal Data in the good faith belief
							that such action is necessary to:`
					},
					{
						type: PolicyTermType.BULLETS,
						data: [
							"To comply with a legal obligation",
							"To protect and defend the rights or property of Clinton Electronics",
							"To prevent or investigate possible wrongdoing in connection with the Service",
							"To protect the personal safety of users of the Service or the public",
							"To protect against legal liability"
						]
					}
				]
			},
			{
				subtitle: "Security of Data",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`The security of your data is important to us, but remember that no method of
							transmission over the Internet, or method of electronic storage is 100%
							secure. While we strive to use commercially acceptable means to protect your
							Personal Data, we cannot guarantee its absolute security.`
					}
				]
			},
			{
				subtitle: "Service Providers",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We may employ third party companies and individuals to facilitate our Service
							("Service Providers"), to provide the Service on our behalf, to perform
							Service-related services or to assist us in analyzing how our Service is used.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`These third parties have access to your Personal Data only to perform these
							tasks on our behalf and are obligated not to disclose or use it for any other purpose.`
					}
				]
			},
			{
				subtitle: "Links To Other Sites",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`Our Service may contain links to other sites that are not operated by us.
							If you click on a third party link, you will be directed to that third party's site.
							We strongly advise you to review the Privacy Policy of every site you visit.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We have no control over and assume no responsibility for the content, privacy
							policies or practices of any third party sites or services.`
					}
				]
			},
			{
				subtitle: "Children's Privacy",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							"Our Service does not address anyone under the age of 18 (\"Children\")."
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We do not knowingly collect personally identifiable information from anyone
							under the age of 18. If you are a parent or guardian and you are aware that your
							Children has provided us with Personal Data, please contact us. If we become
							aware that we have collected Personal Data from children without verification
							of parental consent, we take steps to remove that information from our servers.`
					}
				]
			},
			{
				subtitle: "Changes To This Privacy Policy",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We may update our Privacy Policy from time to time. We will notify you of any
							changes by posting the new Privacy Policy on this page.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`We will let you know via email and/or a prominent notice on our Service, prior
							to the change becoming effective and update the "effective date" at the top of
							this Privacy Policy.`
					},
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							`You are advised to review this Privacy Policy periodically for any changes.
							Changes to this Privacy Policy are effective when they are posted on this page.`
					}
				]
			},
			{
				subtitle: "Contact Us",
				data: [
					{
						type: PolicyTermType.PARAGRAPH,
						data:
							"If you have any questions about this Privacy Policy, please contact us:"
					},
					{
						type: PolicyTermType.BULLETS,
						data: [
							"By email: support@dynamicdns.com",
							"By visiting this page on our website: https://app.dynamicdns.com"
						]
					}
				]
			}
		]
	}
] as Section[];
